import React, { Component } from 'react';
import { connect }          from 'react-redux';

//actions
import { getGeneralDeclaration } from 'redux/actions';

//css
import './index.scss';

//assets
import logo from 'assets/logos/logo.svg';

class Splash extends Component {

    constructor(props) {
        super(props);
        this.state = {
            initialRequests: [
                this.props.getGeneralDeclaration,
            ]
        }
    }

    componentDidMount() {
        this.state.initialRequests[this.props.request_counter]();
    }

    shouldComponentUpdate(nextProps) {
        //update only if previous request is done
        return nextProps.request_counter !== this.props.request_counter;
    }

    componentDidUpdate() {
        this.state.initialRequests[this.props.request_counter]();
    }

    render() {
        return (
            <div className="splash">
                <img className="splash_logo" src={ logo } alt="" />
            </div>
        )
    }
}

//get required state from redux store and map them to the components props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        request_counter:store.state.initial_requests_counter
    }
}

//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getGeneralDeclaration: () => dispatch(getGeneralDeclaration()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Splash);
